module.exports = __webpack_public_path__ + "static/media/Gallery2.09987e15.png";